module.exports = "<div class=\"container\">\r\n  <h2 i18n>Política de cookies</h2>\r\n  <p i18n>\r\n  política de cookies\r\n  </p>\r\n</div>\r\n"